var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"benefits-section"},[(_vm.showTabs)?_c('div',{staticClass:"benefits-tabs"},[(_vm.images && _vm.images.length > 0)?_c('div',{staticClass:"tab-images"},_vm._l((_vm.images),function(img,index){return _c('img',{key:index,staticClass:"tab-img",attrs:{"src":img,"alt":`权益说明${index + 1}`}})}),0):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }